<div class="page" style="height: 100%!important;">
  @if (url) {
    <iframe [src]="url" style="border:none;" height="100%" width="100%" frameborder="0" allowfullscreen="true"
    mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
  }
</div>
